var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeShoter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63148 7.88868H16.3586C16.8508 7.88868 17.243 7.4657 17.243 6.98121C17.243 6.48133 16.8586 6.08142 16.3586 6.08142H1.63148C1.13159 6.08142 0.74707 6.4967 0.74707 6.98121C0.74707 7.45801 1.13929 7.88868 1.63148 7.88868ZM1.63148 11.9184H9.49878C9.99097 11.9184 10.3832 11.4955 10.3832 11.011C10.3832 10.5188 9.99866 10.1112 9.49878 10.1112H1.63148C1.13159 10.1112 0.74707 10.5265 0.74707 11.011C0.74707 11.4878 1.13929 11.9184 1.63148 11.9184Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeShoter);
export default __webpack_public_path__ + "static/media/make-shoter.36b77a42261fd00d7a278dcab8214fe1.svg";
export { ForwardRef as ReactComponent };